const shortHexRegex = /^(.)(.)(.)(.)?$/;
const hexPairRegex = /^(..)(..)(..)(..)?$/;

const extractSpectrumFromHex = (hexColor) => {
  if (hexColor.length === 3 || hexColor.length === 4) {
    return shortHexRegex
      .exec(hexColor)
      .slice(1, 5)
      .map((hue) => (hue ? hue + hue : 'ff'));
  }

  if (hexColor.length === 6 || hexColor.length === 8) {
    const hexArray = hexPairRegex.exec(hexColor).slice(1, 5);
    const alphaSpectrum = hexArray[3];
    if (!alphaSpectrum) {
      hexArray[3] = 'ff';
    }
    return hexArray;
  }

  throw Error(`Invalid hex color string: ${hexColor}`);
};

export default extractSpectrumFromHex;
